module.exports = require("@apollo/client/link/subscriptions");